import React, { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./Home";
import VocalCart from "./pages/VocalCart";
import RecordsView from "./pages/RecordsView";
import { getSavedUser, clearAuth } from "./lib/globalfunction";

const DEFAULT_USER = { FacilityName: "Default" };

function App() {
  const [user, setUser] = useState(getSavedUser() || DEFAULT_USER);

  const handleLogout = () => {
    clearAuth();
    setUser(DEFAULT_USER);
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/home" element={<Home user={user} onLogout={handleLogout} />} />
        <Route path="/vocalis" element={<VocalCart />} />
        <Route path="/records" element={<RecordsView />} />
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="*" element={<Navigate to="/home" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
